import _ from 'lodash';
import React, { useMemo } from 'react';
import { Overlay } from './Overlay';
import { useConfig } from '~/hooks';
import { Form, yup } from '~/forms';
import app from '~/app';

export function PasslessSignInOverlay( props ) {
  const config = useConfig();
  const conf = config.getter( 'settings.passlessSignIn' );
  if ( ! conf( 'enabled', false ) ) {
    throw new Error( `Passless Sign In is not enabled` );
  }
  const formcfg = useMemo( () => {
    const handler = conf( 'handler', 'by-membership-id' );
    return {
      className   : 'form-signin',
      fields      : [
        {
          name      : 'id',
          label     : 'Member or Membership Number',
          required  : false,
          help      : [
            'Locate your membership by your Member ID',
            '(or your Membership Number)',
          ].join( ' ' ),
          validate  : yup.string(),
        },
        {
          name      : 'email',
          label     : 'Email Address',
          required  : false,
          help      : 'Locate your membership by your email address',
          validate  : yup.string(),
        },
        {
          name      : 'phone',
          label     : 'phoneNumber',
          required  : false,
          help      : 'Locate your membership by your phone number',
          validate  : yup.string(),
        },
      ],
      onSubmit( data ) {
        return app.service( 'swipes' ).create( { handler, ...data } );
      },
    };
  }, [ conf ] );
  return (
    <Overlay title="Sign In">
      <Form {...formcfg} />
    </Overlay>
  );
}
PasslessSignInOverlay.propTypes = {};
